import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { HiBars4, HiXMark, HiHome } from "react-icons/hi2";
import { BsFacebook } from "react-icons/bs";
import { FaYoutube } from "react-icons/fa";
import { GrInstagram } from "react-icons/gr";
const links = [
  {
    id: 1,
    title: "Home",
    url: "/",
    icon: <HiHome />,
  },
  {
    id: 2,
    title: "About",
    url: "/about",
    icon: <HiHome />,
  },
  {
    id: 3,
    title: "Contact",
    url: "/contact",
    icon: <HiHome />,
  },
];

const Navbar = () => {
  const location = useLocation();
  const isAdminPage = location.pathname === "/admin";
  const { isLoggedIn, handleLogout, userData } = useAuth();
  const navigate = useNavigate();
  const [nav, setNav] = useState(false);
  const [hasBorder, setHasBorder] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 0) {
        setHasBorder(true);
      } else {
        setHasBorder(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleNav = () => {
    setNav((prev) => !prev);

    if (!nav) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  };

  const isUserAuthenticated = localStorage.getItem("token");

  const handleNavDiv = () => {
    setNav(false);
    document.body.style.overflow = "scroll";
  };

  const handleLinkClick = (url) => {
    navigate(url);
  };

  return (
    <nav
      className={` bg-[#d4c1a7] dark:bg-gray-900 ${
        isAdminPage ? "hidden" : ""
      }  fixed w-full z-20 top-0 left-0 h-16 dark:border-gray-600  ${
        hasBorder
          ? "border-b-2 border-[#d4c1a7]/80 shadow-sm transition-all"
          : ""
      }`}
    >
      <div
        className={`max-w-screen-lg flex flex-wrap items-center justify-between mx-auto p-3`}
      >
        <Link
          onClick={() => navigate("/")}
          className="flex items-center mx-6 lg:mx-8"
        >
          <img
            src={"/logo.png"}
            className="object-contain h-10 w-full"
            alt="logo"
          />
        </Link>

        <div className="flex flex-row-reverse md:flex-row  w-[70] order-1  md:order-last md:hidden mx-6">
          <div
            onClick={handleNav}
            className={`${nav ? "" : ""} bg-[#ee5535] p-1 rounded-md`}
          >
            {nav ? (
              <HiXMark size={30} color="white" />
            ) : (
              <HiBars4 size={30} color="white" />
            )}
          </div>

          <aside
            id="default-sidebar"
            className={` fixed top-0 left-0 z-40 w-[80%] h-full md:h-screen  transform-gpu transition-transform duration-550 ${
              nav ? "translate-x-0 " : "-translate-x-full"
            } `}
          >
            <div className=" py-2 px-3 h-full bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700">
              <div href="/" className=" border-2 border-red-500">
                <img
                  src={"/logo.png"}
                  className="object-contain h-10  "
                  alt="logo"
                />
              </div>
              <div className="space-y-2">
                {links.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => handleLinkClick(item.url)}
                    style={{ cursor: "pointer" }}
                    className="flex gap-2 "
                  >
                    <span className="pt-1">{item.icon}</span>
                    <span > {item.title}</span>
                  </div>
                ))}
              </div>
              <ul className="pt-5 mt-5 space-y-2 border-t border-gray-200 dark:border-gray-700">
                <li>
                  <a
                    href="https://www.facebook.com/grahaksathiind"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group"
                  >
                    <BsFacebook />
                    <span className="ml-3"> Facebook</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCsBlcGkjug_XleT3r363Lbw"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group"
                  >
                    <FaYoutube />
                    <span className="ml-3">Youtube</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/grahaksathiindia/"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group"
                  >
                    <GrInstagram />
                    <span className="ml-3">Instagram</span>
                  </a>
                </li>
                <div className="flex mx-2">
                  {isLoggedIn ? (
                    <button
                      onClick={handleLogout}
                      type="button"
                      className="flex-1  text-white bg-[#ee5535] hover:bg-[#af3921] focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-sm text-sm px-4 py-2 text-center mr-3 md:mr-0 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                    >
                      Logout
                    </button>
                  ) : isUserAuthenticated ? (
                    <>
                      <button
                        onClick={() => navigate("/userDash/reports")}
                        type="button"
                        className="flex-1  text-white bg-[#ee5535] hover:bg-[#af3921] focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-sm text-sm px-4 py-2 text-center mr-3 md:mr-0 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                      >
                        Dashboard
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => navigate("/login")}
                        type="button"
                        className="flex-1  text-white bg-[#ee5535] hover:bg-[#af3921] focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-sm text-sm px-4 py-2 text-center mr-3 md:mr-0 dark:bg-orange-600 dark:hover:bg-orange-700 dark:focus:ring-orange-800"
                      >
                        Login
                      </button>
                      <button
                        onClick={() => navigate("/signup")}
                        type="button"
                        className="flex-1  text-white bg-[#ee5535] hover:bg-[#af3921] focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-sm text-sm px-4 py-2 text-center mr-3 md:mr-0 dark:bg-orange-600 dark:hover:bg-orange-700 dark:focus:ring-orange-800 mx-2"
                      >
                        SignUp
                      </button>
                    </>
                  )}
                </div>
              </ul>
            </div>
          </aside>
        </div>
        {/* {item-3} desktop */}
        <div
          className={`hidden items-center justify-around  md:flex md:w-[50%] md:hover:bg-black-100  md:order-1  md:px-5`}
        >
          {links.map((item) => (
            <a
              className="block px-5 py-5  md:hover:bg-black-100 rounded md:bg-transparent md:text-black md:p-0 hover:md:text-[#ee5535] hover:md:font-bold
                 hover:scale-125 transition-all hover:ease-linear transform-gpu md:w-55"
              href={item.url}
              key={item.id}
            >
              {item.title}
            </a>
          ))}
        </div>
        <div className="hidden md:order-last md:block mx-8">
          {isLoggedIn ? (
            <button
              onClick={handleLogout}
              type="button"
              className="flex-1  text-white bg-[#ee5535] hover:bg-[#af3921] focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-sm text-sm px-4 py-2 text-center mr-3 md:mr-0 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
            >
              Logout
            </button>
          ) : isUserAuthenticated ? (
            <>
              <button
                onClick={() => navigate("/userDash/reports")}
                type="button"
                className="flex-1  text-white bg-[#ee5535] hover:bg-[#af3921] focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-sm text-sm px-4 py-2 text-center mr-3 md:mr-0 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
              >
                Dashboard
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                type="button"
                className="flex-1  text-white bg-[#ee5535] hover:bg-[#af3921] focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-sm text-sm px-4 py-2 text-center mr-3 md:mr-0 dark:bg-orange-600 dark:hover:bg-orange-700 dark:focus:ring-orange-800"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                type="button"
                className="flex-1  text-white bg-[#ee5535] hover:bg-[#af3921] focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-sm text-sm px-4 py-2 text-center mr-3 md:mr-0 dark:bg-orange-600 dark:hover:bg-orange-700 dark:focus:ring-orange-800 mx-2"
              >
                SignUp
              </button>
            </>
          )}
        </div>
      </div>
      {/* empty space */}

      <div
        className={`md:hidden  fixed bottom-0 right-0   ${
          nav ? "backdrop-blur-sm backdrop-grayscale-[.5]" : ""
        } transition-all duration-550 w-[20%] h-[93%] z-20`}
        onClick={handleNavDiv}
      ></div>
    </nav>
  );
};

export default Navbar;
